"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsIdentityValueValidator = void 0;
var account_api_1 = require("@newfront-insurance/account-api");
var class_validator_1 = require("class-validator");
var i18n_iso_countries_1 = require("i18n-iso-countries");
var is_identity_value_1 = require("./is-identity-value");
var IsIdentityValueValidator = /** @class */ (function () {
    function IsIdentityValueValidator() {
    }
    IsIdentityValueValidator.prototype.validate = function (_value, args) {
        var object = args === null || args === void 0 ? void 0 : args.object;
        if (!isPlainTextIdentityLike(object)) {
            return false;
        }
        return (0, is_identity_value_1.isIdentityValue)(object);
    };
    IsIdentityValueValidator.prototype.defaultMessage = function () {
        return 'Malformed identity';
    };
    IsIdentityValueValidator = __decorate([
        (0, class_validator_1.ValidatorConstraint)({ name: 'isIdentityValue' })
    ], IsIdentityValueValidator);
    return IsIdentityValueValidator;
}());
exports.IsIdentityValueValidator = IsIdentityValueValidator;
function isPlainTextIdentityLike(object) {
    if (!object) {
        return false;
    }
    if (!object.type || !Object.keys(account_api_1.IdentityType).find(function (type) { return type === object.type; })) {
        return false;
    }
    if (!object.countryCode || !(0, i18n_iso_countries_1.isValid)(object.countryCode)) {
        return false;
    }
    return true;
}
//# sourceMappingURL=is-identity-value.validator.js.map